import React, { useState, useContext } from 'react';
import DataTable, { createTheme } from 'react-data-table-component';
import { ThemeContext } from 'styled-components';
import {
  TableEmpty,
  CadastroMaquinaModal,
  Icon,
  ModalClose,
  ModalConfirmation,
  Skeleton,
} from '..';
import { notifyError } from '../../utils';
import { icons } from '../../assets';
import { postEditMaquina } from '../../services';
import * as s from './styled-machines-table';

const TableMaquinas = ({ loading, data, buscaMaquinas, listSelectsLists }) => {
  const [closeConfirmation, setCloseConfirmation] = useState(false);
  const { title, colors } = useContext(ThemeContext);
  const [isModalEditVisible, setIsModalEditVisible] = useState(false);
  const [isModalEditVisibleConcluido, setIsModalEditVisibleConcluido] =
    useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [estacaoEditado, setEstacaoEditado] = useState();
  const [maquinaSelecionada, setMaquinaSelecionada] = useState({
    name: '',
    appliance: '',
    estacao: '',
    tipoMaquina: '',
    tipo: '',
    modelo: '',
    voltagem: '',
    efeciencia: '',
    enabledSetpointThing: [],
    enabledVariableThing: [],
  });

  createTheme('darkmode', {
    background: {
      default: colors.card,
    },
    divider: {
      default: colors.disabled,
    },
    highlightOnHover: {
      default: colors.lightgrey,
    },
  });

  const columns = [
    {
      name: 'Máquina',
      selector: '',
      sortable: false,
      minWidth: '185px',
      cell: (row) => (
        <s.Label color={colors.label}>{!row.thing ? '' : row.thing}</s.Label>
      ),
    },
    {
      name: 'Cliente',
      selector: '',
      sortable: false,
      minWidth: '185px',
      cell: (row) => (
        <s.Label color={colors.label}>
          {row.park ? (row.park.customer ? row.park.customer.name : '') : ''}
        </s.Label>
      ),
    },
    {
      name: 'Estação',
      selector: '',
      sortable: false,
      minWidth: '186px',
      cell: (row) => (
        <s.Label color={colors.label}>{row.park ? row.park.name : ''}</s.Label>
      ),
    },
    {
      name: 'Editar',
      selector: '',
      sortable: false,
      maxWidth: '10%',
      cell: (row) => (
        <s.IconButton
          type="button"
          title="Editar máquina"
          onClick={() => {
            setIsModalEditVisible(true);
            setMaquinaSelecionada({
              id: row.id ? row.id : '',
              name: row.thing ? row.thing : '',
              appliance: row.appliance ? row.appliance.description : '',
              applianceId: row.appliance ? row.appliance.id : '',
              estacao: row.park ? row.park.id : '',
              tipoMaquina: row.type ? row.type.id : '',
              tipo: row.appliance ? row.appliance.type.id : '',
              modelo: row.model ? row.model : '',
              voltagem: row.appliance ? row.appliance.v : '',
              enabledSetpointThing: row?.enabledSetpointThing ?? [],
              enabledVariableThing: row?.enabledVariableThing ?? [],
            });
          }}
        >
          <Icon name="pencil" size={18} />
        </s.IconButton>
      ),
      style: {
        display: 'flex',
        justifyContent: 'center',
      },
    },
  ];

  const editarEstacao = (values) => {
    postEditMaquina(maquinaSelecionada.applianceId, {
      model: values.modelo,
      v: values.voltagem,
      type: parseInt(values.tipo, 10),
      park: parseInt(values.estacao, 10),
      description: values.appliance,
      thingId: parseInt(maquinaSelecionada.id, 10),
      enabledSetpoints: values.enabledSetpoints,
      enabledVariables: values.enabledVariables,
    })
      .then(() => {
        setIsModalEditVisible(false);
        setConfirmationModal(false);
        setIsModalEditVisibleConcluido(true);
        buscaMaquinas();
      })
      .catch((error) => {
        if (error && error.message) notifyError(error.message);
        else notifyError('Ocorreu um erro ao salvar a máquina');

        setConfirmationModal(false);
      });
  };

  return (
    <>
      {confirmationModal && (
        <ModalConfirmation
          onClose={() => {
            editarEstacao(estacaoEditado);
          }}
          onCloseConfirmation={setConfirmationModal}
        />
      )}
      {isModalEditVisibleConcluido && (
        <CadastroMaquinaModal
          onClose={() => {
            setIsModalEditVisibleConcluido(false);
          }}
          onCloseConfirmation={setCloseConfirmation}
          setEstacaoConcluido={setIsModalEditVisibleConcluido}
          formikInitialValues={maquinaSelecionada}
          listSelectsLists={listSelectsLists}
          estacaoConcluido={isModalEditVisibleConcluido}
          title="Editar máquina"
          sucesso="Estação editada com sucesso!"
          iconFinal={icons.EstacoesIconEdit}
          isEdicao
        />
      )}
      {isModalEditVisible && (
        <CadastroMaquinaModal
          onClose={() => {
            setIsModalEditVisible(false);
          }}
          onCloseConfirmation={setCloseConfirmation}
          submit={setEstacaoEditado}
          setConfirmationModal={setConfirmationModal}
          setEstacaoConcluido={setIsModalEditVisibleConcluido}
          estacaoConcluido={isModalEditVisibleConcluido}
          formikInitialValues={maquinaSelecionada}
          listSelectsLists={listSelectsLists}
          title="Editar máquina"
          dadosAbaixo="Modifique os dados abaixo:"
          msgButton="Confirme suas modificações"
          labelButton="SALVAR"
          sucesso="Máquina editada com sucesso!"
          estadoValue={maquinaSelecionada.estado}
          iconFinal={icons.EstacoesIconEdit}
          isEdicao
        />
      )}
      {closeConfirmation && (
        <ModalClose
          onClose={() => {
            setIsModalEditVisible(false);
            setCloseConfirmation(false);
          }}
          onCloseConfirmation={setCloseConfirmation}
        />
      )}
      <DataTable
        theme={title === 'light' ? 'default' : 'darkmode'}
        noHeader
        columns={columns}
        data={data}
        highlightOnHover
        fixedHeader
        responsive
        pagination={false}
        persistTableHead
        progressPending={loading}
        noDataComponent={
          <TableEmpty
            titulo="Nenhuma máquina foi encontrada"
            subtitulo="Cadastre máquinas para começar"
            icon={icons.EstacoesIconGray}
          />
        }
        ignoreRowClick
        customStyles={{
          table: {
            style: {
              flex: 1,
              marginTop: '10px',
              marginBottom: '5px',
              height: '100%',
              paddingBottom: '1.0vh',
            },
          },
          headRow: {
            style: {
              borderBottomColor: colors.disabled,
            },
          },
          rows: {
            style: {
              borderBottomColor: colors.disabled,
            },
          },
          cells: {
            style: {
              textAlign: 'center',
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
          headCells: {
            style: {
              textAlign: 'center',
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
        }}
        progressComponent={
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
              padding: 16,
              gap: 8,
            }}
          >
            <Skeleton count={6} height="32px" />
          </div>
        }
      />
    </>
  );
};

export default TableMaquinas;
